var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mealCategories.length)?_c('apexchart',{attrs:{"type":"bar","height":Math.max(360, _vm.mealCategories.length * 34 + 80),"options":_vm.mealsOpts,"series":_vm.mealsSeries}}):_c('empty-state',{attrs:{"icon":"mdi-food","title":_vm.$t('no_data')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }